<template>
      <div class="row">
        <div class="col-md-12">
            <div class="form-inline" v-if="meta.is_active" >
                <label class="mr-2">Filter Table</label>
                <select class="form-control" v-model="meta.is_active" @change="loadIsActive">
                    <option value="2">Show All</option>
                    <option value="1">Show Only Active</option>
                    <option value="0">Show Only Inactive</option>
                </select>
            </div>
            <div class="clearfix"><br></div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="form-inline">
                <label class="mr-2">Showing</label>
                <select class="form-control" v-model="meta.per_page" @change="loadPerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <label class="ml-2">Entries</label>
            </div>
        </div>
      
        <div class="col-md-4 offset-md-4">
            <!-- SEARCH BY DATE -->
            <div class="form-inline float-right " v-if="is_search_by_date">
                <label class="mr-2">Search by Date</label>
                <input type="date" class="form-control" @input="search">
            </div>
            <!-- SEARCH DEFAULT -->
            <div class="form-inline float-right mb-3" v-else>
                <label class="mr-2">Search</label>
                <input type="text" class="form-control" @input="search">
            </div>
        </div>

        <div class="col-md-12">
            <CDataTable striped hover bordered :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty>
                           
              <template #action="{item}">
                <td style='width:450px'>
                  <CButton size="sm" variant="primary" color="success" class="ml-1" @click="assign_user(item.id)" >Assign User</CButton>
                  <CButton size="sm" variant="primary" color="info" class="ml-1" @click="is_uuid ? edit(item.uuid) : edit(item.id)" >Edit</CButton>
                  <CButton size="sm" variant="primary" color="warning" class="ml-1" @click="assign_permission(item.id)" >Assign Permission</CButton>
                  <CButton size="sm" variant="primary" color="danger" class="ml-1 m-1" @click="is_uuid ? destroy(item.uuid) : destroy(item.id)" >Delete</CButton>
                </td>   
              </template>
            </CDataTable>   
        </div>

        <div class="col-md-6">
            <p>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} items</p>
        </div>
      
        <div class="col-md-6">
            <b-pagination
                v-model="meta.current_page"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                align="right"
                @change="changePage"
                aria-controls="dw-datatable"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';
import service from '@/services/service'

export default {
  name: 'Table',
  props: {
    items: Array,
    caption: {
      type: String,
      default: 'Table'
    },
    itemTemp: {
        type: String
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    items: {
        type: Array,
        required: true
    },
    fields: {
        type: Array,
        required: true
    },
    meta: {
        required: true
    },
    is_search_by_date: {
        required: true
    },

  },
  data() {
      return {
          checkedNames: [],
          sortBy: null, 
          sortDesc: false, 
          deleteModal: false,
          selected: null,
          selectID: null,
          inc: 5,
      }
  },
    watch: {
        sortBy(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        },
        sortDesc(val) {
            this.$emit('sort', {
                sortBy: this.sortBy,
                sortDesc: this.sortDesc
            })
        }
    },
   methods:{
        loadPerPage(val) {
            this.$emit('per_page', this.meta.per_page)
        },

        loadIsActive(val) {
            this.$emit('is_active', this.meta.is_active)
        },

        changePage(val) {
            this.$emit('pagination', val)
        },

        search: _.debounce(function (e) {
            this.$emit('search', e.target.value)
        }, 500),


        assign_user: function (id) {
            this.$emit('assign_user', id)
        },

        edit: function (id) {
            this.$emit('edit', id)
        },

        assign_permission: function (id) {
            this.$emit('assign_permission', id)
        },
        
        destroy: function (id) {
            this.$emit('destroy', id)
        },    

        frontEndDateFormat: function(date) {
            return moment(date, 'YYYY-MM-DD').format('DD MMMM YYYY');
        },

  }
 
}
</script>
